import React, { useEffect } from 'react';

const SellerDetails = ({ seller, onChange }) => {
  const saveSellerDetails = () => {
    localStorage.setItem('sellerDetails', JSON.stringify(seller));
    alert('Seller details saved successfully!');
  };

  const loadSellerDetails = () => {
    const savedDetails = localStorage.getItem('sellerDetails');
    if (savedDetails) {
      const parsedDetails = JSON.parse(savedDetails);
      Object.entries(parsedDetails).forEach(([key, value]) => {
        onChange('seller', key, value);
      });
      alert('Seller details loaded successfully!');
    } else {
      alert('No saved seller details found!');
    }
  };

  useEffect(() => {
    const savedDetails = localStorage.getItem('sellerDetails');
    if (savedDetails) {
      const parsedDetails = JSON.parse(savedDetails);
      Object.entries(parsedDetails).forEach(([key, value]) => {
        onChange('seller', key, value);
      });
    }
  }, []);

  return (
    <>
      <div className="form-group">
        <label htmlFor="seller-name">Seller Name:</label>
        <input 
          type="text" 
          id="seller-name" 
          value={seller.name}
          onChange={(e) => onChange('seller', 'name', e.target.value)}
          placeholder="Enter seller name"
        />
      </div>
      
      <div className="form-group">
        <label htmlFor="seller-address">Seller Address:</label>
        <textarea 
          id="seller-address" 
          rows="3" 
          value={seller.address}
          onChange={(e) => onChange('seller', 'address', e.target.value)}
          placeholder="Enter seller address"
        />
      </div>
      
      <div className="form-group">
        <label htmlFor="seller-mobile">Seller Mobile:</label>
        <input 
          type="text" 
          id="seller-mobile" 
          value={seller.mobile}
          onChange={(e) => onChange('seller', 'mobile', e.target.value)}
          placeholder="Enter mobile number"
        />
      </div>
      
      <div className="form-group">
        <label htmlFor="seller-email">Seller Email:</label>
        <input 
          type="email" 
          id="seller-email" 
          value={seller.email}
          onChange={(e) => onChange('seller', 'email', e.target.value)}
          placeholder="Enter email address"
        />
      </div>
      
      <div className="form-group">
        <label htmlFor="seller-gst">Seller GST No:</label>
        <input 
          type="text" 
          id="seller-gst" 
          value={seller.gst}
          onChange={(e) => onChange('seller', 'gst', e.target.value)}
          placeholder="Enter GST number"
        />
      </div>
      
      <div className="form-group">
        <label htmlFor="seller-pan">Seller Pan No.:</label>
        <input 
          type="text" 
          id="seller-pan" 
          value={seller.pan}
          onChange={(e) => onChange('seller', 'pan', e.target.value)}
          placeholder="Enter Pan No."
        />
      </div>

      <div className="form-group">
        <label htmlFor="seller-image">Seller Image:</label>
        <input 
          type="file" 
          id="seller-image" 
          accept="image/*"
          onChange={(e) => {
            const file = e.target.files[0];
            if (file) {
              const reader = new FileReader();
              reader.onload = () => {
                onChange('seller', 'image', reader.result);
              };
              reader.readAsDataURL(file);
            }
          }}
        />
      </div>
      
      <div className="seller-actions">
        <button id="save-seller" onClick={saveSellerDetails}>Save Seller Details</button>
        <button id="load-seller" onClick={loadSellerDetails}>Load Seller Details</button>
      </div>
    </>
  );
};

export default SellerDetails;